import styled from '@emotion/styled';
import { Checkbox, InputNumber, Switch, Tooltip } from 'antd';
import FormField from 'components/FormField';
import { useFormikContext } from 'formik';
import { Question } from 'views/Aide/Scenario/PolicyForm';
import { FV, GroupContainer } from './share';
import { T, useTranslate } from '@tolgee/react';

// TODO: 优化结构
export const InlineContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  line-height: 50px;
  padding: 0 8px;
  background: var(--fett-erp-card-bg);
  > div {
    margin: 0 4px;
  }
  .ant-select {
    width: 100px !important;
  }
`;

export const FieldWrapper = styled.div`
  margin-left: 25px;
`;

export const CheckboxWrapper = styled.div`
  margin-left: -25px;
`;

const dateRangeLimit = {
  min: 7,
  max: 90,
};

const itemRangeLimit = {
  min: 2,
  max: 500,
};

function UserTagGroupField() {
  const { t } = useTranslate();

  const {
    values: {
      userTagGroup: { enable },
    },
  } = useFormikContext<FV>();

  return (
    <GroupContainer>
      <header>
        <h3>{t('remind.用户标签')}</h3>
      </header>
      <div>
        <FormField<FV['userTagGroup']['enable']>
          name="userTagGroup.enable"
          label={t('marketing.启用状态')}
        >
          {({ field: { value, onChange } }) => {
            return (
              <Switch
                checked={value}
                onChange={onChange}
                checkedChildren={t('aide.开')}
                unCheckedChildren={t('aide.关')}
              />
            );
          }}
        </FormField>
        <FieldWrapper>
          <FormField<FV['userTagGroup']['remindScene']['VALUABLE_BUYER']>
            name="userTagGroup.remindScene.VALUABLE_BUYER"
            validate={(value) => {
              const {
                valuableBuyerConfig: { dateRange, itemRange },
              } = value;

              if (!dateRange) {
                return t('remind.请输入天数');
              }

              if (dateRange < dateRangeLimit.min || dateRange > dateRangeLimit.max) {
                return t('remind.天数不可超出min-max', dateRangeLimit);
              }

              if (!itemRange) {
                return t('remind.请输入商品件数');
              }

              if (itemRange < itemRangeLimit.min || itemRange > itemRangeLimit.max) {
                return t('remind.商品数不可超出min-max', itemRangeLimit);
              }

              return undefined;
            }}
          >
            {({ field: { value, onChange, onBlur } }) => {
              const {
                remindSceneEnable,
                valuableBuyerConfig: { dateRange, itemRange },
              } = value;

              const inputDisabled = !enable || !remindSceneEnable;

              const Date = () => (
                <InputNumber
                  disabled={inputDisabled}
                  precision={0}
                  value={dateRange}
                  onChange={(dateRange) => {
                    onChange({
                      ...value,
                      valuableBuyerConfig: {
                        ...value.valuableBuyerConfig,
                        dateRange,
                      },
                    });
                  }}
                  onBlur={onBlur}
                  min={dateRangeLimit.min}
                  max={dateRangeLimit.max}
                />
              );

              const Item = () => (
                <InputNumber
                  disabled={inputDisabled}
                  precision={0}
                  value={itemRange}
                  onChange={(itemRange) => {
                    onChange({
                      ...value,
                      valuableBuyerConfig: {
                        ...value.valuableBuyerConfig,
                        itemRange,
                      },
                    });
                  }}
                  onBlur={onBlur}
                  min={itemRangeLimit.min}
                  max={itemRangeLimit.max}
                />
              );

              return (
                <>
                  <CheckboxWrapper>
                    <Checkbox
                      disabled={!enable}
                      checked={remindSceneEnable}
                      onChange={({ target: { checked } }) => {
                        onChange({
                          ...value,
                          remindSceneEnable: checked,
                        });
                      }}
                    >
                      {t('newScene.VALUABLE_BUYER')}
                    </Checkbox>
                  </CheckboxWrapper>
                  <InlineContainer>
                    <T
                      keyName="remind.当前咨询日期前x天内，买家在该店铺中购买的商品数≥y件"
                      params={{
                        x: <Date />,
                        y: <Item />,
                      }}
                    />
                    <Tooltip
                      title={t(
                        'remind.购买的商品数：COD订单已下单订单中的商品数或非COD订单已付款订单中的商品数',
                      )}
                    >
                      <Question />
                    </Tooltip>
                  </InlineContainer>
                </>
              );
            }}
          </FormField>
        </FieldWrapper>
        <FormField<
          FV['userTagGroup']['remindScene']['NEGATIVE_RATE_PRONE_BUYER']
        > name="userTagGroup.remindScene.NEGATIVE_RATE_PRONE_BUYER">
          {({ field: { value, onChange } }) => {
            const { remindSceneEnable } = value;
            return (
              <Checkbox
                disabled={!enable}
                checked={remindSceneEnable}
                onChange={({ target: { checked } }) => {
                  onChange({
                    ...value,
                    remindSceneEnable: checked,
                  });
                }}
              >
                {t('chat_side_negative_buyer_tag')}
              </Checkbox>
            );
          }}
        </FormField>
      </div>
    </GroupContainer>
  );
}

export default UserTagGroupField;
